/* eslint-disable default-param-last */
const initialState = {
  templateInfo: null,
};

const templateInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TEMPLATE_INFO":
      return { ...state, templateInfo: action.payload };
    default:
      return state;
  }
};

export default templateInfoReducer;
